module.exports = __webpack_public_path__ + "static/media/fcpsr.4629ec1f.svg";